import React from 'react';
import {Chip, Tooltip} from "@mui/material";
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import {IImagePreview} from "@ui/imageListCustom/types";

const ImagePreviewBadge = ({badge, badgeTitle}: Pick<IImagePreview, 'badge' | 'badgeTitle'>) => {
	if (!badge) {
		return null
	}
	return (
		<Tooltip title={badgeTitle ?? ''}>
			<Chip
				size="small"
				icon={<PeopleAltIcon/>}
				label={badge}
				sx={{
					position: 'absolute',
					top: 6,
					right: 6,
					zIndex: 1,
					color: '#fff',
					backgroundColor: 'rgba(0, 0, 0, 0.6)',
					'& .MuiChip-icon': {color: '#fff'},
				}}
			/>
		</Tooltip>
	);
};

export default ImagePreviewBadge;
